<footer class="main-footer">
    <div class="pull-right hidden-xs">
        <b>Version</b> 1.0.0
    </div>
    <strong>Copyright &copy; {{current_year}} <a href="javascript:void(0)">247LiveIt</a>.</strong> All rights reserved.
</footer>
